import { AuthGuard } from '@/router/guards/AuthGuard.js'
import UserAdminPage from '@/views/Admin/User/UserAdminPage.vue'
import OrganizationAdminPage from '@/views/Admin/Organizations/OrganizationAdminPage.vue'
import SupportMessagesAdminPage from '@/views/Admin/SupportMessagesAdminPage.vue'
import StylesPreviewPage from '@/views/Admin/StylesPreviewPage.vue'
import UserInvitesAdminPage from '@/views/Admin/UserInvites/UserInvitesAdminPage.vue'
import ResourcesAdminPage from '@/views/Admin/Resources/ResourcesAdminPage.vue'
import OrganizationGroupsAdminPage from '@/views/Admin/OrganizationGroups/OrganizationGroupsAdminPage.vue'
import PortalSettingsPage from '@/views/Admin/PortalSettings/PortalSettingsPage.vue'
import DocumentsAdminPage from '@/views/Admin/Documents/DocumentsAdminPage.vue'
import DataSubmissionsAdminPage from '@/views/Admin/DataSubmissions/DataSubmissionsAdminPage.vue'
import SuperAdminPage from '@/views/Admin/SuperAdmin/SuperAdminPage.vue'
import OrganizationRoleAdminPage from '@/views/Admin/Roles/OrganizationRoleAdminPage.vue'
import OrganizationRoleEditPage from '@/views/Admin/Roles/OrganizationRoleEditPage.vue'
import ScheduledReportsAdminPage from '@/views/Admin/Reports/ScheduledReports/ScheduledReportsAdminPage.vue'

export default [
	{
		path: '/admin/users',
		name: 'admin.users',
		component: UserAdminPage,
		meta: {
			authGuard: AuthGuard.RequireAdmin,
			title: 'Admin | Users'
		}
	},
	{
		path: '/admin/user-invites',
		name: 'admin.user-invites',
		component: UserInvitesAdminPage,
		meta: {
			authGuard: AuthGuard.RequireAdmin,
			title: 'Admin | User Invites'
		}
	},
	{
		path: '/admin/organizations',
		name: 'admin.organizations',
		component: OrganizationAdminPage,
		meta: {
			authGuard: AuthGuard.RequireAdmin,
			title: 'Admin | Organizations'
		}
	},
	{
		path: '/admin/organizations/roles',
		name: 'admin.organizations.roles',
		component: OrganizationRoleAdminPage,
		meta: {
			authGuard: AuthGuard.RequireAdmin,
			title: 'Admin | Organization Roles'
		}
	},
	{
		path: '/admin/organizations/roles/edit',
		name: 'admin.organizations.roles.edit',
		component: OrganizationRoleEditPage,
		meta: {
			authGuard: AuthGuard.RequireAdmin,
			title: 'Admin | Organization Roles | Edit'
		}
	},
	{
		path: '/admin/organization-groups',
		name: 'admin.organization-groups',
		component: OrganizationGroupsAdminPage,
		meta: {
			authGuard: AuthGuard.RequireAdmin,
			title: 'Admin | Organization Groups'
		}
	},
	{
		path: '/admin/support/messages',
		name: 'admin.support.messages',
		component: SupportMessagesAdminPage,
		meta: {
			authGuard: AuthGuard.RequireAdmin,
			title: 'Admin | Support Messages'
		}
	},
	{
		path: '/admin/styles',
		name: 'admin.styles',
		component: StylesPreviewPage,
		meta: {
			authGuard: AuthGuard.RequireAdmin,
			title: 'Admin | Styles Preview'
		}
	},
	{
		path: '/admin/resources',
		name: 'admin.resources',
		component: ResourcesAdminPage,
		meta: {
			authGuard: AuthGuard.RequireAdmin,
			title: 'Admin | Resources'
		}
	},
	{
		path: '/admin/portal-settings',
		name: 'admin.portal-settings',
		component: PortalSettingsPage,
		meta: {
			authGuard: AuthGuard.RequireAdmin,
			title: 'Admin | Tenant Settings'
		}
	},
	{
		path: '/admin/documents',
		name: 'admin.documents',
		component: DocumentsAdminPage,
		meta: {
			authGuard: AuthGuard.RequireAdmin,
			title: 'Admin | Documents'
		}
	},
	{
		path: '/admin/data-submissions',
		name: 'admin.data-submissions',
		component: DataSubmissionsAdminPage,
		meta: {
			authGuard: AuthGuard.RequireAdmin,
			title: 'Admin | Data Submissions'
		}
	},
	{
		path: '/admin/super-admin',
		name: 'admin.super-admin',
		component: SuperAdminPage,
		meta: {
			authGuard: AuthGuard.RequireAdmin,
			title: 'Admin | Super Admin'
		}
	},
	{
		path: '/admin/reports/scheduled-reports',
		name: 'admin.reports.scheduled-reports',
		component: ScheduledReportsAdminPage,
		meta: {
			authGuard: AuthGuard.RequireAdmin,
			title: 'Admin | Super Admin'
		}
	}
]
